import { Component, Input } from '@angular/core';

/**
 * A component that renders an SVG icon for "Magnify"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-magnify',
    templateUrl: './icon-magnify.component.html',
    styleUrls: ['./icon-magnify.component.scss'],
    standalone: false
})
export class IconMagnifyComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
